export default __webpack_public_path__ + "static/media/resume.aa020578.pdf";